import { BaseTypeSchema } from "../BaseTypeSchema";
import { VariableType } from "../VariableType";

export class EmailSchema extends BaseTypeSchema
{
    static REGEX: RegExp = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    constructor(required: boolean)
    {
        super(VariableType.Email, required);
    }
}